import { HOST } from '@/app/src/app/config/env'
import { isServer } from '@/app/src/shared/lib/isServerClient'

type IGetFullUrl = {
  url: string
  hash: string
  urlAbsolute: string
}

export const getFullUrl = (): IGetFullUrl => {
  if (isServer) {
    return {
      url: '',
      hash: '',
      urlAbsolute: '',
    }
  }

  const location = window.location
  const [, ...segments] = location.pathname.split('/')
  const pathname = segments.join('/')
  const search = location.search
  const hash = location.hash

  const url = search.length ? `${pathname}${search}` : pathname

  return {
    url,
    urlAbsolute: `${HOST}/${url}`,
    hash,
  }
}
